import { Injectable } from '@angular/core';

@Injectable()
export class ModalRedirectToService {
  private element: any;

  init(el) {
    this.element = el;
  }

  open(url) {
    this.element.open(url);
  }

  clonse() {
    this.element.close();
  }
}
